<p [class]="cssClass" [innerHTML]="displayDescription">
</p>
